export default __webpack_public_path__ + "static/topic23-c57946b4f95daef341fc209cf87af4c2.png";